/**
 * Número em destaque com rótulo e detalhe — o bloco de leitura rápida do
 * painel.
 *
 * Existe porque um valor único NÃO é um gráfico: uma barra sozinha não
 * comunica nada que o número já não diga, e ainda ocupa dez vezes mais espaço.
 */

/** Estado que a métrica representa, quando ela tiver um. */
export type StatTone = 'neutral' | 'good' | 'warning' | 'critical';

interface StatTileProps {
  label: string;
  value: string;
  detail?: string;
  tone?: StatTone;
  /** Destaca o número principal da tela (maior corpo). */
  hero?: boolean;
}

export function StatTile({ label, value, detail, tone = 'neutral', hero = false }: StatTileProps) {
  return (
    <div className={`stat-tile${hero ? ' stat-tile--hero' : ''}`}>
      <span className="stat-tile__label">{label}</span>
      <strong className={`stat-tile__value stat-tile__value--${tone}`}>
        {/* A cor de estado nunca vem sozinha: o ícone textual acompanha, para
            quem não distingue as cores e para o modo de alto contraste. */}
        {tone === 'critical' && <span aria-hidden="true">⚠ </span>}
        {value}
      </strong>
      {detail && <span className="stat-tile__detail">{detail}</span>}
    </div>
  );
}
